import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getLeadSourceEventListData } from './mockData'
import type { ILeadSourceEvent } from '~/types/leadSource/models'

// get

interface GetLeadSourceEventsResponse {
  data: ILeadSourceEvent[]
}

async function getLeadSourceEvents(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetLeadSourceEventsResponse = {
    data: await getLeadSourceEventListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postLeadSourceEvent = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getLeadSourceEventListData)
}

const patchLeadSourceEvent = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getLeadSourceEventListData)
}

const deleteLeadSourceEvent = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getLeadSourceEventListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/leadsourceevents',
    handler: getLeadSourceEvents,
  },
  {
    method: 'post',
    path: '/api/leadsourceevents',
    handler: postLeadSourceEvent,
  },
  {
    method: 'patch',
    path: '/api/leadsourceevents/:id',
    handler: patchLeadSourceEvent,
  },
  {
    method: 'delete',
    path: '/api/leadsourceevents/:id',
    handler: deleteLeadSourceEvent,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
